module.exports = __webpack_public_path__ + "vue-assets/img/special_edition.cf7a8d04.png";